<template>
  <div>
    <el-dialog
      title="上传影像"
      :visible.sync="visible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="handleDialogClosed"
    >
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="影像文件" prop="imageFile">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :before-upload="beforeUpload"
            :on-progress="handleProgress"
            :on-success="handleSuccess"
            :on-error="handleError"
            :data="uploadData"
            :http-request="customUpload"
            accept=".zip"
            :show-file-list="false"
            :disabled="uploadProgress > 0"
          >
            <el-button type="primary" :disabled="uploadProgress > 0">
              选择文件
            </el-button>
            <div slot="tip" class="el-upload__tip">
              <div>
                1.压缩文件名建议使用字母或数字，中文或特殊字符命名可能会解析错误。
              </div>
              <div>2.只能上传.ZIP格式文件，且不超过1G。</div>
              <div>3.重复上传会覆盖原有影像数据。</div>
            </div>
          </el-upload>
        </el-form-item>
        <el-progress
          v-if="uploadProgress > 0"
          :percentage="uploadProgress"
          :status="uploadStatus"
        ></el-progress>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Api from "../../../api";
import axios from "axios";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        imageFile: "",
      },
      GuidList: {
        ReportGuid: "",
        HospitalGuid: "",
      },
      uploadProgress: 0,
      uploadStatus: "",
      uploadUrl:
        process.env.VUE_APP_BASE_API + Api.api.manager.UploadImageByRptId,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      uploadData: {},
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    beforeUpload(file) {
      // 检查文件大小（1GB = 1024 * 1024 * 1024 bytes）
      const isLt1G = file.size / 1024 / 1024 / 1024 <= 1;
      if (!isLt1G) {
        this.$message.error("上传文件大小不能超过 1GB!");
        return false;
      }

      // 检查文件类型
      const isZip =
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed";
      if (!isZip) {
        this.$message.error("只能上传 ZIP 格式文件!");
        return false;
      }

      // 设置上传参数
      this.uploadData = {
        reportGuid: this.GuidList.ReportGuid,
        hospitalGuid: this.GuidList.HospitalGuid,
      };
      console.log(this.uploadData, "this.uploadData");
      this.uploadProgress = 0;
      this.uploadStatus = "";
      return true;
    },
    handleProgress(event) {
      this.uploadProgress = Math.round(event.percent);
    },
    handleSuccess(response) {
      if (response.StatusCode === 200) {
        this.uploadStatus = "success";
        this.$message.success("上传成功");
        this.visible = false;
        this.$emit("uploadSuccess");
      } else {
        this.uploadStatus = "exception";
        this.$message.error(response.Message || "上传失败");
      }
    },
    handleError() {
      this.uploadStatus = "exception";
      this.$message.error("上传失败");
    },
    customUpload({ file }) {
      const formData = new FormData();
      formData.append("file", file);
      //   formData.append("reportGuid", this.GuidList.ReportGuid);
      //   formData.append("hospitalGuid", this.GuidList.HospitalGuid);

      axios
        .post(
          this.uploadUrl +
            "?reportGuid=" +
            this.GuidList.ReportGuid +
            "&hospitalGuid=" +
            this.GuidList.HospitalGuid,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ...this.headers,
            },
            onUploadProgress: (progressEvent) => {
              const complete =
                ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              this.uploadProgress = complete;
            },
          }
        )
        .then((response) => {
          this.handleSuccess(response.data);
        })
        .catch(() => {
          this.handleError();
        });
    },
    handleDialogClosed() {
      // 重置所有状态
      this.form.imageFile = "";
      this.uploadProgress = 0;
      this.uploadStatus = "";
      this.uploadData = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-demo {
  .el-upload__tip {
    margin-top: 10px;
    color: #909399;
  }
}
</style>
